import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';

export const initStateReferralCheck = {
  referralCheck: { data: null, loading: false, error: null },
};

export const referralCheck = createAsyncThunk('tariff/referralCheck', async (data, { rejectWithValue, fulfillWithValue }) => {
  const token = localStorage?.getItem('token');
  if (!token) rejectWithValue({ error: 'PROBLEM_WITH_TOKEN' });
  return await axios
    .post(
      `${process.env.REACT_APP_SERVER_API}/auth/profile/check-referral-code/`,
      { referral_code: data },
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    )
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      console.log(res);
      return rejectWithValue(res.response.data);
    });
});

export const reducerReferralCheck = {
  [referralCheck.pending]: (state) => {
    state.referralCheck.loading = true;
    state.referralCheck.error = null;
  },
  [referralCheck.fulfilled]: (state, action) => {
    state.referralCheck.loading = false;
    state.referralCheck.data = action.payload;
    state.referralCheck.error = null;
  },
  [referralCheck.rejected]: (state, action) => {
    state.referralCheck.loading = false;
    state.referralCheck.error = action.payload;
  },
};
